import { useTranslation } from "react-i18next";
import { DetailsRow } from "../../../../components/DetailsRow";
import {
  formatDateWithYearAndTime,
  formatDeliveryProviderName,
} from "../../../../util";
import { CardHeader } from "../../../../components/CardHeader";
import { Order } from "../../model/OrderSuccessResponse";

interface OrderDeliveryInformationProps {
  order: Order | undefined;
}

export const OrderDeliveryInformation = ({
  order,
}: OrderDeliveryInformationProps) => {
  const { t } = useTranslation();

  return (
    <div className="card">
      <CardHeader title="Delivery information" />
      <div className="card-body d-flex flex-column" style={{ gap: "16px" }}>
        <DetailsRow leftText="Delivery id" rightText={order?.displayId} />
        <DetailsRow
          leftText="Delivery address"
          rightText={order?.delivery?.addressLine}
        />
        {order?.delivery?.provider !== undefined && (
          <DetailsRow
            leftText="Courier service"
            rightText={formatDeliveryProviderName(order?.delivery?.provider)}
          />
        )}
        {order?.delivery?.estimated_restaurant_pickup.from !== undefined && (
          <DetailsRow
            leftText="Estimated kitchen pickup from"
            rightText={t("order_details.date", {
              date: formatDateWithYearAndTime(
                order?.delivery?.estimated_restaurant_pickup.from!
              ),
            })}
          />
        )}
        {order?.delivery?.estimated_restaurant_pickup.to !== undefined && (
          <DetailsRow
            leftText="Estimated kitchen pickup to"
            rightText={t("order_details.date", {
              date: formatDateWithYearAndTime(
                order?.delivery?.estimated_restaurant_pickup.to!
              ),
            })}
          />
        )}
        {order?.delivery?.estimated_user_arrival.from !== undefined && (
          <DetailsRow
            leftText="Estimated user arrival from"
            rightText={t("order_details.date", {
              date: formatDateWithYearAndTime(
                order?.delivery?.estimated_user_arrival.from!
              ),
            })}
          />
        )}
        {order?.delivery?.estimated_user_arrival.to !== undefined && (
          <DetailsRow
            leftText="Estimated user arrival to"
            rightText={t("order_details.date", {
              date: formatDateWithYearAndTime(
                order?.delivery?.estimated_user_arrival.to!
              ),
            })}
          />
        )}
      </div>
    </div>
  );
};
